import React, { useState, useEffect } from 'react';
import Loader from '../components/utils/Loader';
import Portlet from '../components/utils/Portlet';
import ReactPaginate from 'react-paginate';
import Input from '../components/utils/Input'
import ErrorContainer from '../components/utils/ErrorContainer';
import Content from '../components/layout/Content';
import DateInput from '../components/utils/DateInput';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { fetchDocumentation, setFiltersDocumentation, setPagingDocumentation } from '../action';
import { useSelector } from 'react-redux';
import { fromStore, userRoleSelector } from '../selectors';
import DocumentationList from '../containers/documentation/DocumentationList';
import { Link } from 'react-router-dom';
import { setUIvisible } from '../action/UImobile';
import { roleId } from '../constants/app';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

function DocumentationPage() {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState();
    const paging = useSelector(fromStore.pagingDocumentationSelector);
    const count = useSelector(fromStore.countDocumentationSelector);
    const filters = useSelector(fromStore.filtersDocumentationSelector);
    const items = useSelector(fromStore.documentationListSelector);
    const loader = useSelector(fromStore.loaderDocumentationSelector);
    const role = useSelector(userRoleSelector);
    const UImobile = useSelector(state => state.UImobile);

    useEffect(() => {
        dispatch(fetchDocumentation());
    }, [dispatch, paging]);

    useEffect(() => {
        dispatch(setUIvisible(true, false));
    }, [dispatch]);

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        setCurrentPage(0);
        dispatch(setPagingDocumentation(updatedPaging));
    }

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        let nextStart =  data.selected * paging.limit;
        const updatedPaging = {...paging, start: nextStart};
        dispatch(setPagingDocumentation(updatedPaging));
    };

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 400)
            return 1;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        if(userDisplayWidth < 1250)
            return 5;

        return 8;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;

        if(userDisplayWidth < 550)
            return 2;

        if(userDisplayWidth < 850)
            return 3;

        return 5;
    }

    const renderPagination = () => {
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />
                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    const resetFilter = () => {
        dispatch(setFiltersDocumentation({ city: null, point: null, status: null }))
        setCurrentPage(0);
        dispatch(fetchDocumentation());
    }

    const onChangeDateInput = (field) => (date) => {
        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {
            updated.createdEndDate = moment(date).add({ days: 30 }).toDate()
        }
        dispatch(setFiltersDocumentation(updated))
    }

    const onChangeInput = (field) => (e) => {
        const value = e.target.value;
        const updated = {
            ...filters,
            [field]: value
        }
        dispatch(setFiltersDocumentation(updated))
    }

    const onSearch = () => {
        dispatch(setPagingDocumentation({ ...paging, start: 0 }));
        setCurrentPage(0);
        dispatch(fetchDocumentation());
    }

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            onSearch(); 
        }
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main" onKeyDown={onKeyDown}>
                    <h3 className="kt-subheader__title">Документы</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc" id="kt_subheader_total">
                            {count}
                        </span>
                    </div>                    
                </div>
                <div className="kt-subheader__toolbar">
                    {[roleId.admin, roleId.chiefMarketingSpecialist].includes(role) && (
                        <Link className="btn btn-success btn-icon-sm" to="/addDocumentation">Добавить документ</Link>
                    )}
                </div>
            </div>
            </div>
        );
    }

    if (loader) {
        return (
            <div style={styles.loading}><Loader /></div>
        );
    }

    return (
        <Content>
            { renderSubHeader() }
            <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="kt-portlet__body">
                    <div className="kt-form kt-form--label-right kt-margin-t-10">
                        {(window.innerWidth > 1024 || UImobile.openFilters) && 
                            <div className="filterBlocks">
                                <div>
                                    <div className="dateBlock">
                                        <DateInput
                                            placeholderText="Дата от"
                                            selected={filters.createdStartDate}
                                            onChange={onChangeDateInput('createdStartDate')}
                                            maxDate={moment().toDate()}
                                        />
                                        <div>-</div>
                                        <DateInput
                                            placeholderText="Дата до"
                                            selected={filters.createdEndDate}
                                            onChange={onChangeDateInput('createdEndDate')}
                                            maxDate={moment(filters.createdStartDate).add({ days: 30 }).toDate()}
                                            required={filters.createdStartDate}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: 250 }}>
                                    <Input placeholder="Заголовок" onChange={onChangeInput('title')} disableGroup={true} value={filters.title}/>
                                </div>
                                <div>
                                    <button style={{ marginRight: 5 }} onClick={onSearch} className="btn btn-primary">Найти</button>
                                    <button onClick={resetFilter} className="btn btn-danger">Сбросить</button>
                                </div>
                            </div>
                        }
                    </div>
                </div> 
                <Portlet fit={true}>
                    <ErrorContainer field="documentation" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        <DocumentationList items={items}/>
                        {
                            items.length > 0 && renderPagination()
                        }
                    </div>
                </Portlet>
            </div>
        </Content>
    );
}

export default DocumentationPage;